var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 17.137 7.493 37.08a4.029 4.029 0 1 0 5.697 5.698l19.942-19.942a4.029 4.029 0 1 0-5.697-5.698Z",
    fill: "#1AD3BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 17.137 7.493 37.08a4.029 4.029 0 1 0 5.697 5.698l19.942-19.942a4.029 4.029 0 1 0-5.697-5.698Z",
    fill: "#1AD3BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.45 10.729a8.058 8.058 0 0 0 0 11.396l5.698 5.697a8.058 8.058 0 0 0 11.395 0l6.41-6.41a8.058 8.058 0 0 0 0-11.395l-5.698-5.698a8.058 8.058 0 0 0-11.395 0l-6.41 6.41Zm17.805 3.561a3.022 3.022 0 1 0-4.273-4.273 3.022 3.022 0 0 0 4.273 4.273Z",
    fill: "#985184"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.149 27.822 4.986-4.985a4.03 4.03 0 0 0-5.698-5.698l-4.986 4.986 5.698 5.697Z",
    fill: "#005E7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/Rental.f43515b49975a2e6f509535cf7280bd0.svg";
export { ForwardRef as ReactComponent };